import { useCallback } from 'react';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import type { CareCreditEnrollDisclosureNavigationProps } from '../care-credit-enroll-disclosure.types';

export const CareCreditEnrollDisclosureGenericNavigation = ({
  body: Body,
}: CareCreditEnrollDisclosureNavigationProps) => {
  const {
    multiStep: { goPrevStep, goNextStep },
    isCareCreditRestrictedState,
    setCareCreditMessageType,
  } = useCollectPaymentMultiContext();

  const onGoBack = useCallback(() => {
    goPrevStep({ orStep: PAYMENT_MULTI_STEPS.paymentMethods });
  }, [goPrevStep]);

  const onCompleteStep = useCallback(() => {
    if (isCareCreditRestrictedState) {
      setCareCreditMessageType('payment-link');
      goNextStep({
        orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure,
      });
    } else {
      goNextStep({ orStep: PAYMENT_MULTI_STEPS.careCreditEnroll });
    }
  }, [goNextStep, isCareCreditRestrictedState]);

  return <Body onGoBack={onGoBack} onCompleteStep={onCompleteStep} />;
};
